import Vue from "vue";

// 메뉴 정의
let menu = {
  home : { title: 'Home', icon: 'mdi-home', to: '/home' },

  // 소유한 계정 (하위 계정) 관리 메뉴
  account :  {
    title: 'Account Management',
    icon: 'mdi-account-details',
    to: '/account-management',
  },

  // Owner 가 소유한 마켓 관리
  market :  {
    title: 'Market Management',
    icon: 'mdi-account-details',
    to: '/market-management',
  },

  // Ven 계정에 부여되는 Code 관리
  vencode : {
    title: 'Ven Management',
    icon: 'mdi-numeric',
    to: '/ven-management',
  },

  // Owner 계정 전용 메뉴 모음
  owner_menu : {
    title: 'Menu',
    icon: 'mdi-menu',
    // 하위 메뉴들
    items: [
      { title: 'Ven Sales', icon: 'mdi-store-search', to: '/menu/ven-sales' }
    ],
  },

  // Ven 계정 전용 메뉴 모음
  ven_menu : {
    title: 'Menu',
    icon: 'mdi-menu',
    items: [
      { title: 'Sales', icon: 'mdi-store-search', to: '/menu/sales' }
    ],
  },
};

// 계정 등급 별로 등급의 이름과 사용할 수 있는 메뉴가 다릅니다. 
// 배열의 인덱스로 접근하여 관리했습니다.
let accounts = [
  {
    accountTypeName : 'Admin',
    accountMenu : [
      menu.home, 
      menu.account
    ],
  },
 {
    accountTypeName : 'Manager',
    accountMenu : [
      menu.home, 
      menu.account,
      menu.market 
    ],
  },
  {
    accountTypeName : 'Owner',
    accountMenu : [
      menu.home, 
      menu.account, 
      menu.vencode,
      menu.owner_menu 
    ],
  },
  {
    accountTypeName : 'Ven',
    accountMenu : [
      menu.home, 
      menu.ven_menu
    ],
  },
];

const state = {
  drawer: true, // 햄버거 메뉴 숨김&표시용
  accountInfo : accounts, 
};

const getters = {
  getDrawer: state => state.drawer,
  // 쿠키에 저장된 계정 정보를 읽어서 페이지를 구성합니다 

  getUserId : function(){
    return Vue.$cookies.get('user_id')
  },
  getAccountTypeName: function(state) {
    return state.accountInfo[Vue.$cookies.get('type')].accountTypeName;
  },
  getAccountMenu: function(state) {
    return state.accountInfo[Vue.$cookies.get('type')].accountMenu;
  }
};

const mutations = {
  setDrawer(state, data) {
    state.drawer = data;
  },
};

const actions = {
  toggleDrawer({ commit }, value) {
    commit('setDrawer', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
